<script setup>
import Dependency from '@cta/frontend/javascripts/dependency.js';
import browserService from '@cta/frontend/services/BrowserService';
import trackingService from '@cta/frontend/services/TrackingService.js';
import '@campact/camper/core/CmprButton';
import '@campact/camper/core/CmprFormHint';
import CmprInput from '@cta/frontend/components/CmprInput.vue';
import { ref, useTemplateRef } from 'vue';

const contactCallGateway = Dependency.resolve('ContactCallGateway');

defineProps({
  searchButtonText: {
    type: String,
    required: true,
  },
  searchInputPlaceholder: {
    type: String,
    required: true,
  },
});

const form = useTemplateRef('form');
const postalcode = ref('');
const postalcodeError = ref(null);

async function submit() {
  postalcodeError.value = null;
  const { success, redirectUrl, errors } = await contactCallGateway.search(postalcode.value);

  if (success) {
    trackingService.dispatchSendForm(form.value, { context: 'contact-lookup' });
    browserService.redirect(redirectUrl);
  } else if (errors) {
    postalcodeError.value = errors.postalcode;
  } else {
    browserService.reload();
  }
}
</script>

<template>
  <form
    ref="form"
    data-analytics-id="contact-call-search-form"
    @submit.prevent="submit"
  >
    <div class="contact-call_search">
      <div>
        <CmprInput
          v-model="postalcode"
          autocomplete="postal-code"
          data-analytics-context="contact-lookup"
          data-analytics-id="contact-call-search-form-postalcode-field"
          data-analytics-inner-text="postalcode"
          inputmode="numeric"
          :placeholder="searchInputPlaceholder"
          required="required"
        />

        <cmpr-form-hint
          v-if="postalcodeError"
          variant="error"
        >
          {{ postalcodeError }}
        </cmpr-form-hint>
      </div>

      <cmpr-button
        data-analytics-context="contact-lookup"
        data-analytics-id="contact-call-search-form-commit-button"
        size="medium"
        variant="secondary"
        @click.prevent="submit"
      >
        {{ searchButtonText }}
      </cmpr-button>
    </div>
  </form>
</template>
